import React, { Component } from 'react';
import './ErrorBoundary.css';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary">
          <p className="error-boundary-message">Ocorreu um erro ao carregar esta tela.</p>
          <button type="button" className="btn btn-primary error-boundary-button" onClick={this.handleReload}>
            Recarregar
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
